(function ($) {
  'use strict';

  /**
   * Main functionality should be in an 'init' function
   */
  var initSimplifiedLandingHero = function () {

    var $self;
    var $showMoreBtn;
    var $video;
    var mediaQuery;
    var mediaQueryList;
    var checkBreakpoint;

    $self = $(this);
    $showMoreBtn = $('.show-more', $self);
    $video = $('video', $self);
    mediaQuery = '(min-width: 1024px)';
    mediaQueryList = window.matchMedia(mediaQuery);

    $showMoreBtn.on('click', function () {
      $(this).toggleClass('is-active');
    });

    checkBreakpoint = function () {
      if (this.matches) {
        if ($video.length > 0) {
          $video.attr('autoplay', '');
          $video[0].play();

          var promise = $video[0].play();

          if (promise !== undefined) {
            promise.then(function() {
              // Autoplay started!
            }).catch(function(error) {
              // Autoplay was prevented.
              $('.f--ambient-video').hide();
              $('.f--image').show();
              $('.cc--video-controls').hide();
              $('.cc--info-controls .buttons').addClass('single-button');
            });
          }
        }
      }
      else {
        if ($video.length > 0) {
          $video.removeAttr('autoplay');
          $video[0].pause();
        }
      }
    };

    if ($video.length === 0) {
      $('.cc--video-controls button').attr('disabled', 'true');
    }

    if ($video.length > 0 ) {
      mediaQueryList.addEventListener('change', checkBreakpoint);
      checkBreakpoint.apply(mediaQueryList);

      setTimeout(() => {
        $('.cc--video-controls button').removeAttr('disabled');
      }, 1000)
    }

    $('body').addClass('transparent-header');

    ScrollTrigger.observe({
      target: window,
      type: 'scroll',
      onUp: () => {
        window.pageYOffset == 0 && !$('html').hasClass('main-menu-open') ? $('body').addClass('transparent-header') : null;
      }
    });
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   */
  window.DP.behaviors.simplifiedLandingHero = {
    attach: function (context) {
      $(context).find('.cc--simplified-landing-hero').once('simplifiedLandingHero').each(function () {
        initSimplifiedLandingHero.apply(this);
      });
    }
  };

}(jQuery));
